import React from 'react'
import ReactPaginate from 'react-paginate'

export default function Pagination({ totalRow, perPage, currentPage, onPageChange }) {
    return (
        <ReactPaginate
            previousLabel={<span>←</span>}
            nextLabel={<span>→</span>}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={(Math.round((totalRow / perPage) >= 1 ? (totalRow / perPage) : 1))}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            onPageChange={(page) => onPageChange(page.selected)}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination-li"}
            activeClassName={"curent"}
            forcePage={(currentPage - 1) ? (currentPage - 1) : 0}
        />
    )
}
